/** Invitations must not reuse another child's local draft. */
export const registrationDraftKey = (token: string) => `sus-register-data:${token}`;
export function readRegistrationDraft(
  storage: Pick<Storage, 'getItem'>,
  token: string,
): Record<string, unknown> | null {
  if (!token) return null;
  try {
    const raw = storage.getItem(registrationDraftKey(token)) ?? storage.getItem('sus-register-data');
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== 'object' || !('token' in value) || value.token !== token) return null;
    return value as Record<string, unknown>;
  } catch {
    return null;
  }
}
